import { render, staticRenderFns } from "./PanelPlatformInfo.vue?vue&type=template&id=7a62bd99&scoped=true"
import script from "./PanelPlatformInfo.vue?vue&type=script&lang=js"
export * from "./PanelPlatformInfo.vue?vue&type=script&lang=js"
import style0 from "./PanelPlatformInfo.vue?vue&type=style&index=0&id=7a62bd99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a62bd99",
  null
  
)

export default component.exports